
// src/web/components/chat-album-image-item.jsx

import React from 'react'
import _ from 'lodash'
import moment from 'moment'


class AlbumImageItem extends React.Component {
  showImagesView = (image)=> this.props.showImagesView('OUT_OF_LIST', undefined, image)
  render() {
    const {
      image,
      users,
      showImagesView,
    } = this.props

    const num = image && image.name.lastIndexOf('.')
    const basename = num != -1 && image.name.slice(0, num) || image.name
    const extension = num != -1 && image.name.slice(num + 1, image.name.length).toLowerCase() || ''
    // ファイル名が長い場合は途中を...で省略する
    const imagename = (basename.length > 20 ? basename.slice(0, 20) + '...' + extension : image.name)

    return (
      <div style={{padding: '2.5%', cursor: 'pointer'}} onClick={()=> this.showImagesView(image)}>
        <div style={{display: 'flex', justifyContent: 'center',alignItems: 'center', height: '75%', borderTopLeftRadius: 10, borderTopRightRadius: 10}}>
          <img src={image.file.url} 
            style={{ height: '100%',width: '100%', objectFit: 'cover',borderTopLeftRadius: 10, borderTopRightRadius: 10}}/>
        </div>
        <div style={{backgroundColor: '#dadce0', height: '25%', padding: '5px 16px 5px 16px', borderBottomLeftRadius: 10, borderBottomRightRadius: 10}}>
          <p style={{ color: 'rgb(33, 33, 33)' }}>{imagename}</p>
          <p style={{ color: 'rgb(117, 117, 117)' }}>{image.user.name}</p>
          <p style={{ color: 'rgb(117, 117, 117)' }}>{moment(image.created_at).format('LLL')}</p>
        </div>
      </div>
    )
  }
}

export default AlbumImageItem



// WEBPACK FOOTER //
// ./src/web/components/album-image-item.jsx